<template slot-scope="scope">
  <!-- 店铺申诉（样式对齐右侧反馈弹框） -->
  <dialogModel
    title="申诉"
    :visible="dialogAppeal"
    @handleClose="handleCloseAppeal"
    @handleOk="handleAppeal"
  >
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="申诉内容" prop="textarea">
          <el-input
            type="textarea"
            placeholder="请输入至少15个字的申诉内容"
            v-model="ruleForm.textarea"
            show-word-limit
            maxlength="3000"
            resize="none"
            :autosize="true"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <label style="margin-top: 20px; margin-bottom: 10px; display: block"
        >上传资料：</label
      >
      <div class="Upload-box">
        <input
          type="file"
          @change="onFileChange"
          id="fileAppeal"
          ref="batchImport"
        />
        <input
          type="button"
          value="点击上传"
          class="btn firm-clickable"
          @click="clickFile"
        />
        <p>请上传zip文件，大小在10MB以内</p>
        <p style="color: #409eff ">{{ fileName }}</p>
      </div>
    </div>
  </dialogModel>
</template>

<script>
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  props: {
    dialogAppeal: {},
  },
  data() {
    return {
      ruleForm: { textarea: "" },
      rules: {
        textarea: vxRule(true, "", "blur", "请输入申诉内容"),
      },
      fileName: "",
      TXurlPath: "",
      docId: "",
      docName: "",
    };
  },
  methods: {
    clickFile() {
      if (this.$refs.batchImport) {
        this.$refs.batchImport.click();
      }
    },
    async onFileChange(event, opt) {
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) return;
      var fileSuffix = file.name.split(".").pop();
      if (String(fileSuffix).toLowerCase() !== "zip") {
        this.$tool.PromptBox("error", "请上传zip文件");
        if (this.$refs.batchImport) this.$refs.batchImport.value = "";
        return;
      }
      this.fileName = file.name;
      var arr = await this.$tool.onFileChangeNew(event, opt);
      if (arr && arr.code == 0) {
        this.TXurlPath = arr.docPath || arr.TXurl;
        this.docId = arr.docId;
        this.docName = arr.docName;
      }
      if (this.$refs.batchImport) this.$refs.batchImport.value = "";
    },
    handleCloseAppeal() {
      this.$emit("handleCloseAppeal");
    },
    handleAppeal() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleAppeal");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-textarea .el-input__count {
  bottom: -30px !important;
}
/deep/.el-form-item {
  margin-bottom: 6px;
}
/deep/.el-form-item__label {
  text-align: left !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
  min-height: 80px !important;
}
/deep/.el-form-item.is-error .el-textarea__inner {
  border-color: #fe574a !important;
}

.Upload-box {
  width: 250px;
  height: 100px;
  border: 1px dashed #409eff ;
  margin-right: 20px;

  #fileAppeal {
    display: none;
  }

  input {
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    width: 100%;
    text-align: center;
    color: #409eff ;
    margin-top: 40px;
  }
  p {
    width: 100%;
    text-align: center;
    font-size: 10px;
  }
}
</style>
